'use client';

import { useEffect } from 'react';
import { initializeDatadogRUM } from '@/lib/datadog';

/**
 * DatadogRUM component that initializes Datadog RUM on the client side
 * This component should be included in the root layout
 */
export default function DatadogRUM() {
  useEffect(() => {
    // Initialize Datadog RUM only on the client side
    const isInitialized = initializeDatadogRUM();
    
    if (isInitialized) {
      // Set global context for the documentation app
      import('@/lib/datadog').then(({ setGlobalContext }) => {
        setGlobalContext({
          appType: 'documentation',
          appName: 'llm-docs-app',
          framework: 'nextjs',
        });
      });
    }
  }, []);

  // This component doesn't render anything
  return null;
} 